export default __webpack_public_path__ + "static/media/granada.f4fc4e4f.jpg";